import React, { useState, useEffect } from 'react';

const Toast = ({ message, isVisible, onClose, duration = 2000, type = 'success' }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const getToastStyles = () => {
    const baseStyles = {
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 9999,
      padding: '12px 20px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      maxWidth: '400px',
      animation: 'slideInRight 0.3s ease-out',
      border: '1px solid'
    };

    switch (type) {
      case 'success':
        return {
          ...baseStyles,
          backgroundColor: '#FFFFFF',
          color: '#5A4A42',
          borderColor: '#C8B5A0'
        };
      case 'error':
        return {
          ...baseStyles,
          backgroundColor: '#FFFFFF',
          color: '#D32F2F',
          borderColor: '#FFCDD2'
        };
      case 'warning':
        return {
          ...baseStyles,
          backgroundColor: '#FFFFFF',
          color: '#F57C00',
          borderColor: '#FFE0B2'
        };
      default:
        return {
          ...baseStyles,
          backgroundColor: '#FFFFFF',
          color: '#5A4A42',
          borderColor: '#D4C4B0'
        };
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div style={getToastStyles()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {type === 'success' && (
              <i className="feather icon-check-circle" style={{ marginRight: '8px', color: '#7CB342' }}></i>
            )}
            {type === 'error' && (
              <i className="feather icon-x-circle" style={{ marginRight: '8px', color: '#D32F2F' }}></i>
            )}
            {type === 'warning' && (
              <i className="feather icon-alert-triangle" style={{ marginRight: '8px', color: '#F57C00' }}></i>
            )}
            <span>{message}</span>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#8B7B73',
              cursor: 'pointer',
              marginLeft: '12px',
              padding: '0',
              fontSize: '16px'
            }}
          >
            ×
          </button>
        </div>
      </div>
    </>
  );
};

export default Toast;
